export enum STATE_ORDER_DISPATCH {
  CREATED = 'Creado',
  IN_PICKING = 'En Picking',
  TO_CONSOLIDATE = 'Por consolidar',
  CONSOLIDATED = 'Consolidado',
  PRE_DISPATCH = 'Pre-despacho',
  IN_CONSOLIDATION = 'En Consolidacion',
  TO_LOCATE = 'Por Ubicar',
  INCOMPLETE_PICKING = 'Picking Incompleto',
  INCOMPLETE = 'Incompleto',
  CANCELLED = 'Cancelado',
  TO_WITHDRAW = 'Por Retirar',
  LOCATED = 'Ubicado',
  DISPATCHED = 'Despachado'
}
